import Button from "../core/Button";
import GameConfig from "../core/data/GameConfig";
import Strings from "../core/data/Strings";
import ResizableContainer from "../core/ResizableContainer";
import { UserMediaContainer } from "../core/UserMediaContainer";
import PhotoSelectScene from "../scenes/PhotoSelectScene";
import Fonts from "../utils/Fonts";
import LayoutUtils from "../utils/LayoutUtils";
import Photo from "./Photo";

export default class PhotoSelectCarousel extends ResizableContainer {
	frameContainer: Phaser.GameObjects.Container;
	private photoFrames: Photo[] = [];
	private photos: string[] = [];
	private photoSelectScene: PhotoSelectScene;

	private photoIndex = 0;
	photo: Phaser.GameObjects.Image;
	userMediaContainer: UserMediaContainer
	thumbBG: Phaser.GameObjects.Image;
	displayText: Phaser.GameObjects.Text;
	adjust: number;
	startPos: Phaser.Math.Vector2;
	totalDistance: number;
	leftMax: number;
	rightMax: number;
	get currentPhoto(): Photo {
		return this.photoFrames.find(frame => frame.isEnabled());
	}

	private nextButton: Button;
	private prevButton: Button;
	spinner: Phaser.GameObjects.Image;
	photoHeader: Phaser.GameObjects.Image;
	tweenUpObjs: (Phaser.GameObjects.Image | Button | Phaser.GameObjects.Container)[];
	photoTweenObjs: (Phaser.GameObjects.Image | UserMediaContainer)[];
	constructor(scene: PhotoSelectScene, index = 0) {
		super(scene, 0, 0);
		this.photoSelectScene = scene;
		this.photos = [
			"takePhotoDoll17",
			"takePhotoDoll16",
			"takePhotoDoll14",
			"takePhotoDoll10",
			"takePhotoDoll9",
			"takePhotoDoll13",
			"takePhotoDoll12",
			"takePhotoDoll15",
			"takePhotoDoll11",
			"takePhotoDoll1",
			"takePhotoDoll7",
			"takePhotoDoll3",
			"takePhotoDoll5",
			"takePhotoDoll2",
			"takePhotoDoll8",
			"takePhotoDoll6",
			"takePhotoDoll4",
		];
		
		this.photoIndex = index;
		const count = this.photos.length;
		const center = Math.floor(count / 2);
		this.frameContainer = scene.add.container();
		const thumbBG = this.thumbBG = scene.add.image(0, 0, "takePhotoTumbBacker");
		const thumbBGL = scene.add.image(0, 0, "takePhotoTumbBacker");
		const thumbBGR = scene.add.image(0, 0, "takePhotoTumbBacker");
		this.frameContainer.setSize(thumbBG.width, thumbBG.height);
		this.photoFrames = [];

		for (let i = 0; i < count; i++) {
			const pIndex = this.roundIndex(index - center + i);
			// const type = pIndex == 0 ? 'camera' : 'photoSelect';
			const photo = new Photo(scene, this.photos[pIndex], false, false);
			photo.enablePhoto(false);
			photo.setScale(0.29);
			// photo.setScale((this.frameContainer.width/6) / photo.width);
			photo.setSize(this.frameContainer.width/6, this.frameContainer.height);
			this.frameContainer.add(photo);
			this.photoFrames.push(photo);
			photo.sizer.setVisible(false);

			photo.picture.setInteractive();
			photo.picture.on(Phaser.Input.Events.POINTER_DOWN, () => {
				this.scene.soundManager.play("click");
				this.selectPhoto(photo);
			}, this);

			this.enableDragging(photo.picture);
		}
		this.alignPhotos();
		// this.frameContainer.bringToTop(this.photoFrames[center]);
		this.setSize(scene.viewport.width, scene.viewport.height);

		
		const corkL = scene.add.image(0, 0, "takePhotoCorkCorner");
		const corkR = scene.add.image(0, 0, "takePhotoCorkCorner");
		corkL.setInteractive();
		corkR.setInteractive();
		corkR.setFlipX(true);
		const adjust = this.adjust = GameConfig.get("carouselAdjust") as number;
		this.nextButton = scene.add.button(0, 0, "takePhotoBtnR", undefined, () => this.nextPhoto(adjust), this, true);
		this.prevButton = scene.add.button(0, 0, "takePhotoBtnL", undefined, () => this.nextPhoto(-adjust), this, true);
		this.add([thumbBG, thumbBGL, thumbBGR, this.frameContainer, corkL, corkR, this.prevButton, this.nextButton]);

		this.addResize(() => {
			this.setSize(scene.viewport.width, scene.viewport.height);
			scene.alignIn.Center(this, scene.viewport);
			scene.alignIn.BottomCenter(thumbBG, this, -this.width/2, -this.height/2);
			scene.alignTo.LeftCenter(thumbBGL, thumbBG);
			scene.alignTo.RightCenter(thumbBGR, thumbBG);
			scene.alignIn.BottomLeft(corkL, this, this.width/2, -this.height/2);
			scene.alignIn.BottomRight(corkR, this, -this.width/2, -this.height/2);
			scene.alignIn.Center(this.prevButton, corkL, -10, 10);
			scene.alignIn.Center(this.nextButton, corkR, 10, 10);
		})

		const photoBase = scene.add.image(0, 0, "takePhotoBase");
		const userMedia = this.userMediaContainer = scene.add.userMediaContainer(0, 0, {video: {facingMode: 'user'}});
		this.photo = scene.add.image(0, 0, "waitingForCamera");


		const photoMask = scene.add.image(0, 0, "takePhotoMask");
		photoMask.setVisible(false);
		const mask = photoMask.createBitmapMask();
		// mask.invertAlpha = true;
		this.photo.setMask(mask);
		userMedia.setMask(mask);
		const photoShadow = scene.add.image(0, 0, "takePhotoShadow");
		const photoCorners = scene.add.image(0, 0, "takePhotoCorners");
		const photoGuide = scene.add.image(0, 0, "takePhotoGuides");
		const photoHeader = this.photoHeader = scene.add.image(0, 0, "takePhotoHeader");
		photoHeader.setVisible(false);
		const headerText = this.displayText = scene.add.text(0, 0, Strings.get("TakePhoto"), {
			fontFamily: Fonts.LunchBoxRegular,
			fontSize: "46px",
			align: "center",
		})
		headerText.setVisible(false);
		this.add([photoBase, this.photo, userMedia, photoShadow, photoCorners, photoGuide, photoHeader, headerText]);
		const spinner = this.spinner = scene.add.image(0, 0, "spinner");
		const spinTween = this.scene.tweens.add({
			targets: spinner,
			angle: {from: 0, to: 360},
			duration: 5000,
			repeat: -1
		});
		this.add(this.spinner);
		userMedia.on(userMedia.ON_MEDIA_STREAM_STARTED, () => {
			scene.hasCameraEnabled = true;
			const streamSize = userMedia.getStreamSize();
			const streamRatio = streamSize.x/streamSize.y;
			const maskRatio = photoMask.width/photoMask.height;
			if (streamRatio < maskRatio) {
				userMedia.scale = Math.min(photoMask.width / streamSize.x);
			} else {
				userMedia.scale = Math.min(photoMask.height / streamSize.y);
			}
			headerText.setVisible(true);
			photoHeader.setVisible(true);
			this.spinner.setVisible(false);
			spinTween.stop();
		});
		userMedia.on(userMedia.ON_MEDIA_STREAM_FAILED, () => {
			scene.hasCameraEnabled = false;
			userMedia.setAlpha(0);
			this.spinner.setVisible(false);
			spinTween.stop();
			if (this.currentPhoto == undefined) this.selectPhoto(this.photoFrames[8]);
		});
		
		this.addResize(() => {
			scene.alignIn.Center(photoMask, scene.viewport, 0, -70);
			scene.alignIn.Center(photoBase, this, -this.width/2, -this.height/2 - 70);
			scene.alignIn.Center(this.photo, photoBase);
			scene.alignIn.Center(this.spinner, this.photo);
			scene.alignIn.Center(userMedia, photoBase);
			scene.alignIn.Center(photoShadow, photoBase);
			scene.alignIn.Center(photoCorners, photoBase);
			scene.alignIn.Center(photoGuide, photoBase);
			scene.alignIn.BottomCenter(photoHeader, photoBase, 0, -10);
			scene.alignIn.Center(headerText, photoHeader, 0, -5);
		})

		this.alignPhotos();

		this.tweenUpObjs = [thumbBG, thumbBGL, thumbBGR, corkL, corkR, this.prevButton, this.nextButton, this.frameContainer];
		this.photoTweenObjs = [photoMask, photoBase, this.photo, this.spinner, userMedia, photoShadow, photoCorners, photoGuide];
	}

	enableDragging(obj: Phaser.GameObjects.GameObject)
	{
		obj.setInteractive();
		this.scene.input.setDraggable(obj);
		obj.addListener('dragstart', this.onDragStart, this);
		obj.addListener('drag', this.onDrag, this);
		obj.addListener('dragend', this.onDragEnd, this);
	}

	onDragStart(ptr: Phaser.Input.Pointer)
	{
		this.startPos = new Phaser.Math.Vector2(ptr.x, ptr.y);
		this.totalDistance = 0;
		this.leftMax = this.photoFrames[0].x - this.photoFrames[0].width/2
		this.rightMax = this.photoFrames[this.photoFrames.length-1].x + this.photoFrames[0].width/2
	}
	
	onDrag(ptr: Phaser.Input.Pointer, dragX: number, dragY: number)
	{
		if (this.startPos == undefined) this.startPos = new Phaser.Math.Vector2(ptr.x, ptr.y);
		for (const photo of this.photoFrames) {
			photo.x += ptr.x - this.startPos.x;
		}
		if (this.photoFrames[0].x <= this.leftMax) {
			this.nextPhotoDrag(1)
		} 
		else if (this.photoFrames[this.photoFrames.length-1].x >= this.rightMax) {
			this.nextPhotoDrag(-1);
		}
		this.totalDistance += ptr.x - this.startPos.x;
		this.startPos = new Phaser.Math.Vector2(ptr.x, ptr.y);
	}

	onDragEnd(ptr: Phaser.Input.Pointer)
	{
		this.startPos = undefined;
		this.enableInput(false);

		const change = this.totalDistance % this.photoFrames[0].width;
		let dif = change;
		if (Math.abs(change) > this.photoFrames[0].width/2) dif = -((Math.sign(change) * this.photoFrames[0].width) - change);
		for (let i = 0; i < this.photoFrames.length; i++) {
			const frame = this.photoFrames[i];
			const end = frame.x - dif;
			const tween = this.scene.add.tween({
				targets: frame,
				x: end,
				duration: 300,
				ease: Phaser.Math.Easing.Quadratic.InOut,
			});
			tween.on('complete', () => this.enableInput(true));
		}
	}

	protected nextPhotoDrag(direction: 1 | -1): void {
		this.photoIndex = this.roundIndex(this.photoIndex + direction);
		// this.enableInput(false);

		this.cycleArray(this.photoFrames, direction > 0);
		const frameIndex = direction > 0 ? this.photoFrames.length - 1 : 0;
		const nextIndex = direction > 0 ? this.photoFrames.length - 2 : 1;
		this.photoFrames[frameIndex].x = this.photoFrames[nextIndex].x + (direction * this.photoFrames[nextIndex].width)
	}

	protected nextPhoto(count: number): void {
		const direction = (count > 0) ? 1 : -1;
		this.photoIndex = this.roundIndex(this.photoIndex + count);
		this.enableInput(false);

		for (let i = 0; i < Math.abs(count); i++) this.cycleArray(this.photoFrames, direction > 0);

		// Update the picture for the cycled photo frame
		const frameIndex = direction > 0 ? this.photoFrames.length - 1 : 0;
		const indexOffset = Math.floor(this.photoFrames.length / 2);
		const photoIndex = this.roundIndex(this.photoIndex + Math.sign(direction) * indexOffset);
		this.photoFrames[frameIndex].setPhoto(this.photos[photoIndex]);

		this.alignPhotos();
		const center = Math.floor(this.photoFrames.length / 2);
		this.frameContainer.bringToTop(this.photoFrames[center]);

		const xOffset = (this.photoFrames[0].width) * count;
		for (let i = 0; i < this.photoFrames.length; i++) {
			const frame = this.photoFrames[i];
			const start = frame.x + xOffset;
			const end = frame.x;
			frame.x = start;
			const tween = this.scene.add.tween({
				targets: frame,
				x: end,
				duration: GameConfig.get("carouselTweenTime") as number,
				ease: Phaser.Math.Easing.Quadratic.InOut,
			});
			tween.on('complete', () => this.enableInput(true));
		}
	}

	selectPhoto(frame: Photo): void {
		this.photo.setTexture(frame.photoKey);
		this.spinner.setVisible(false);
		if(this.photoHeader.visible == false){
			this.photoHeader.setVisible(true);
			this.displayText.setVisible(true);
		}
		this.photoSelectScene.disableCamera();
		if (this.currentPhoto) this.currentPhoto.enablePhoto(false);
		frame.enablePhoto(true);
	}

	enableInput(enable: boolean): void {
		const buttons = [this.nextButton, this.prevButton];
		for (const button of buttons) {
			if (enable) button.setInteractive();
			else button.disableInteractive();
		}
	}

	protected alignPhotos(): void {
		const size = new Phaser.Math.Vector2(this.photoFrames[0].width, 0);
		LayoutUtils.alignGrid(this.scene, this.photoFrames, this.frameContainer, size, this.photoFrames.length, 256 - size.x * this.adjust, this.thumbBG.y + 10);
	}

	protected cycleArray(array: any[], foreward: boolean): void {
		const element = foreward ? array.shift() : array.pop();
		if (foreward) array.push(element); 
		else array.splice(0, 0, element);
	}

	protected roundIndex(index: number): number {
		const offset = index % this.photos.length;
		if (offset >= 0) return offset;
		return this.photos.length + offset; 
	}
}